import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useNotificationTabContentStyles = makeStyles((theme) =>
  createStyles({
    containerNotification: {
      width: 476,
      height: 607,
      overflow: 'hidden'
    },

    menuEmpty: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 100,
      paddingBottom: 100
    },

    bottomNav: {
      borderTop: `1px solid ${theme.palette.text.disabled}`,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },

    tab: {
      minWidth: 'max-content',
      flex: 1
    },

    badge: {
      '&:after': {
        content: '""',
        width: theme.spacing(0.5),
        height: theme.spacing(0.5),
        borderRadius: '100%',
        color: '#fff',
        backgroundColor: theme.palette.primary.main,
        position: 'absolute',
        left: theme.spacing(0.5),
        top: theme.spacing(1.5)
      }
    },

    tabContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },

    tabPanel: {
      padding: 0
    },

    buttonRead: {
      marginLeft: 'auto',
      paddingLeft: 20,
      marginRight: theme.spacing(2),
      height: '100%'
    },

    notificationHeader: {
      height: 43,
      background: '#F8F8F8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 25,
      paddingRight: 13
    },
    notificationHeaderTitle: {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: 14
    },
    settingBtn: {
      background: 'inherit',
      outline: 'none',
      border: 'none',
      cursor: 'pointer'
    }
  })
)
